import type { PolicyTypes } from '~types/TokenGateTypes';

const isValidPolicy = (policy: string): policy is PolicyTypes => {
  return ['public', 'holders', 'traits'].includes(policy);
};

export default isValidPolicy;
